const EllipseIcon = ({ size = '100%', ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox="0 0 439 439"
    preserveAspectRatio="xMidYMin meet"
    fill='none'
    {...props}
  >
    <circle cx="219.5" cy="219" r="219" stroke='#F4F4F4' />
  </svg>
);

export default EllipseIcon;